import React from 'react'
import { Customers } from 'pages/Customers/Customers'
import { EmbeddedCustomers } from 'pages/EmbeddedCustomers/EmbeddedCustomers'

interface NestedCustomersProps {
  isPrincipleCustomer?: boolean
  isEmbeddedCustomer?: boolean
}

export const NestedCustomers = ({
  isPrincipleCustomer = false,
  isEmbeddedCustomer = false,
}: NestedCustomersProps) => {
  if (isEmbeddedCustomer) return <EmbeddedCustomers />
  if (isPrincipleCustomer) return <Customers />
  return null
}
